import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FormBaseModel } from '@smarttask-common/src/lib/models/Form/Core/FormBaseModel';

export enum FormActionTypes {
    ADD_FORM = '[Form] Create Form',
    ADD_FORMS = '[Form] Add Forms',
    UPSERT_FORM = '[Form] Upsert Form',
    UPSERT_FORMS = '[Form] Upsert Forms',
    UPDATE_FORM = '[Form] Update Form',
    UPDATE_FORMS = '[Form] Update Forms',
    DELETE_FORM = '[Form] Delete Form',
    DELETE_FORMS = '[Form] Delete Forms',
    DELETE_ALL_FORMS = '[Form] Delete All Forms',
    DELETE_ALL = '[Form] Delete All',

    UPDATE_SELECTED_ID = '[Form] Update SelectedId',
}

export class UpdateSelectedFormId implements Action {
    readonly type = FormActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_form_id: string) {}
}

export class AddOne implements Action {
    readonly type = FormActionTypes.ADD_FORM;
    constructor(public form: FormBaseModel) {}
}

export class AddMany implements Action {
    readonly type = FormActionTypes.ADD_FORMS;
    constructor(public forms: Array<FormBaseModel>) {}
}

export class UpsertOne implements Action {
    readonly type = FormActionTypes.UPSERT_FORM;

    constructor(public form: FormBaseModel) {}
}

export class UpsertMany implements Action {
    readonly type = FormActionTypes.UPSERT_FORMS;
    constructor(public forms: Array<FormBaseModel>) {}
}

export class UpdateOne implements Action {
    readonly type = FormActionTypes.UPDATE_FORM;
    constructor(public form: Update<FormBaseModel>) {}
}

export class UpdateMany implements Action {
    readonly type = FormActionTypes.UPDATE_FORMS;
    constructor(public forms: Array<Update<FormBaseModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = FormActionTypes.DELETE_FORM;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = FormActionTypes.DELETE_FORMS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = FormActionTypes.DELETE_ALL_FORMS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = FormActionTypes.DELETE_ALL;
    constructor() {}
}

export type FormActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedFormId;
